export const SECTIONS = [
  ["seo", "SEO i udostępnianie"], ["brand", "Logo i nagłówek"], ["hero", "Sekcja główna"], ["gallery", "Galeria realizacji"], ["packs", "Pakiety"],
  ["process", "Jak działamy"], ["addons", "Dodatki"], ["owners", "Dla właścicieli"], ["testimonials", "Opinie klientów"], ["instagram", "Instagram"], ["faq", "FAQ"],
  ["calendar", "Kalendarz terminów"], ["contact", "Kontakt i formularz"], ["footer", "Stopka i regulamin"],
];

export const SECTION_HINTS = {
  seo: "Tytuł i opis pokazują się w wynikach Google i na karcie przeglądarki. Zdjęcie jest używane przy udostępnianiu linku.",
  instagram: "Wgraj zdjęcia z Instagrama i przy każdym wklej link do posta. Pasek pojawi się na stronie, gdy dodasz pierwsze zdjęcie.",
  testimonials: "Odznacz „Pokaż na stronie”, żeby ukryć sekcję opinii.",
  calendar: "Zaznacz „Pokaż na stronie”, żeby włączyć kalendarz. Gdy jest włączony, klient nie wyśle zapytania na zajęty dzień.",
};

export const LABELS = {
  part1: "Logo – część 1", part2: "Logo – część 2 (złota)", nav_cta: "Przycisk w menu",
  label: "Nadtytuł (mały, złoty)", title: "Tytuł", title_em: "Tytuł – druga część (złota)", lead: "Opis", text: "Opis",
  cta_primary: "Przycisk główny", cta_secondary: "Przycisk drugi", trust: "Wyróżniki", items: "Elementy",
  subtitle: "Podpis", alt: "Opis zdjęcia (dla niewidomych)", image: "Zdjęcie", tall: "Wysoki kafel (2 rzędy)",
  button: "Tekst przycisku", occasion: "Okazja (nazwa w formularzu)", desc: "Krótki opis", features: "Co zawiera",
  price: "Cena (zł)", featured: "Wyróżniony", flag: "Etykieta wyróżnienia", steps: "Kroki", when: "Kiedy",
  fine: "Drobny druk", name: "Nazwa", q: "Pytanie", a: "Odpowiedź", phone: "Telefon (wyświetlany)",
  whatsapp: "Numer WhatsApp (same cyfry, z 48)", email: "E-mail", instagram: "Instagram", other_occasion: "Nazwa opcji „inna okazja”",
  budgets: "Opcje budżetu", submit: "Tekst przycisku formularza", copyright: "Prawa autorskie", nip: "NIP", terms: "Regulamin (treść)",
  enabled: "Pokaż na stronie", rating: "Ocena (1–5)", description: "Opis strony (Google, ok. 150 znaków)", blocked: "Zajęte terminy", position: "Widoczny fragment w kafelku",
  profile_url: "Link do profilu na Instagramie", link: "Link do posta (np. https://www.instagram.com/p/…)", photos: "Zdjęcia z pobytu (max 3)",
};

export const LABEL_OVERRIDES = {
  "seo.title": "Tytuł strony (karta przeglądarki i Google)", "seo.image": "Zdjęcie do udostępniania (Facebook, WhatsApp)",
  "testimonials.items.occasion": "Okazja i miejsce", "testimonials.items.image": "Zdjęcie (opcjonalnie)", "testimonials.items.name": "Imię / imiona",
};

export const TEMPLATES = {
  trust: { title: "", text: "" },
  "gallery.items": { title: "", subtitle: "", alt: "", image: "", tall: false, position: "50% 50%" },
  "packs.items": { occasion: "", title: "", desc: "", features: [], price: 0, featured: false, flag: "" },
  steps: { when: "", title: "", text: "" },
  "addons.items": { name: "", desc: "", price: 0 },
  "owners.items": { title: "", text: "" },
  "faq.items": { q: "", a: "" },
  "testimonials.items": { name: "", occasion: "", text: "", rating: 5, image: "", photos: [] },
  "instagram.items": { image: "", link: "", alt: "" },
};

export const LONG = ["lead", "text", "desc", "a", "terms", "fine", "description"];
